<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import { Button, Modal, ModalBody, ModalHeader } from "sveltestrap";
  import { AddContact, NewContacts } from "../../../utils/Constant/Constant";
  import NewContactForm from "./NewContactForm.svelte";
  let open:boolean = false;
  const toggle = () => {
    open = !open
  };
  
</script>
<li class="nav-item">
    <Button class="badge-light-primary btn-block btn-mail w-100" on:click={toggle} >
      <FeatherIcon class="me-2" icon="users" /> {NewContacts}
    </Button>
    <div class="modal fade modal-bookmark" tabindex="-1" aria-hidden="true">
        <Modal isOpen={open} {toggle} class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <ModalHeader>{AddContact}
              <Button class="btn-close" on:click={toggle}></Button>
            </ModalHeader>
            <ModalBody>
              <NewContactForm open={open}/>
            </ModalBody>
          </div>
        </Modal>
    </div>
</li>